<template>
  <div class="l8-side-menu-wrapper" :class="{ 'open': toggle }">
    <h3>
      {{ title }}
      <div class="toggle" @click="onToggle">
        <l8-icon type="icon-liebiao1"></l8-icon>
      </div>
    </h3>
    <div class="mask" @click="onToggle"></div>
    <div class="cell-body">
      <div class="toggle">
        <l8-icon type="icon-liebiao1" @click="onToggle"></l8-icon>
      </div>
      <a-menu
        mode="inline"
        :openKeys="openKey"
        :defaultSelectedKeys="selectedKey"
        @openChange="onOpenChange"
      >
        <template
          v-for="menu in menus"
        >
          <a-menu-item
            v-if="!menu.child || !menu.child.length"
            :key="menu.title"
          >
            <a v-if="menu.url" href="javascript:void(0);" :title="menu.title" @click="onClick(menu)">
              {{ menu.title }}
            </a>
            <span v-else>
              {{ menu.title }}
            </span>
          </a-menu-item>
          <a-sub-menu
            v-else
            :key="menu.title"
          >
            <span slot="title">
              <a v-if="menu.url" href="javascript:void(0);" :title="menu.title" @click="onClick(menu)">
                {{ menu.title }}
              </a>
              <span v-else>
                {{ menu.title }}
              </span>
            </span>
            <a-menu-item
              v-for="subMenu in menu.child"
              :key="subMenu.title"
            >
              <a href="javascript:void(0);" :title="subMenu.title" @click="onClick(subMenu)">
                {{ subMenu.title }}
              </a>
            </a-menu-item>
          </a-sub-menu>
        </template>
      </a-menu>
    </div>
  </div>
</template>

<script>
import { findIndex } from 'lodash'

export default {
  name: 'sideMenu',
  props: {
    menus: {
      type: Array
    },
    active: {
      type: String
    },
    title: {
      type: String
    }
  },
  data () {
    return {
      toggle: false,
      openKey: [],
      selectedKey: []
    }
  },
  created () {
    const { menus, active } = this

    if (!menus || !menus.length) {
      return
    }

    let menu
    let subMenu

    if (!active) {
      this.openKey = [menus[0].title]
    } else {
      for (let i = 0, len = menus.length; i < len; i++) {
        menu = menus[i]

        if (active === menu.title) {
          this.openKey = [menu.title]
          this.selectedKey = [menu.title]
          break
        }

        if (menu.child && menu.child.length) {
          for (let j = 0, sLen = menu.child.length; j < sLen; j++) {
            subMenu = menu.child[j]

            if (active === subMenu.title) {
              this.selectedKey = [subMenu.title]
              this.openKey = [menu.title]
              break
            }
          }
        }
      }
    }
  },
  methods: {
    onOpenChange (openKeys) {
      const latestOpenKey = openKeys.find(key => this.openKey.indexOf(key) === -1)

      if (findIndex(this.menus, { title: latestOpenKey }) === -1) {
        this.openKey = openKeys
      } else {
        this.openKey = latestOpenKey ? [latestOpenKey] : []
      }
    },
    onToggle () {
      this.toggle = !this.toggle
    },
    onClick ({ url }) {
      if (url) {
        if (location.pathname === url) {
          return
        }

        if (url.startsWith('/micro/main')) {
          this.$router.push({
            path: url.replace('/micro/main', '')
          })
        } else {
          location.href = url
        }
      }
    }
  }
}
</script>
